import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import moment from "moment";

import styles from "./GaldermaChatScriptTable.module.css";
import Conversations from "../Conversations/Conversations";
import {getGaldermaChatConversation} from "../../utils/Api";
import { handleLoaderEvent } from "../../utils/LoaderEmitter";

interface ChatTranscriptItem {
  conversationID: string;
  question: string;
  timeStamp: string;
  username: string;
}

interface ChatTranscriptList extends Array<ChatTranscriptItem> {}

interface Props {
  chatTranscriptList: ChatTranscriptList;
}

const  GaldermaChatScriptTable = ({ chatTranscriptList }: Props) => {
  const [itemsPerPage, setitemsPerPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState<ChatTranscriptList>(chatTranscriptList);
  const [conversationView, setConversationView] = useState(false);
  const [messages, setMessages] = useState([])

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(chatTranscriptList.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(chatTranscriptList.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, chatTranscriptList]);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % chatTranscriptList.length;
    setItemOffset(newOffset);
  };

  const openConversation = async(conversationID:any) => {
    handleLoaderEvent.emit("loader", true);
    const chatConversation = await getGaldermaChatConversation(conversationID);
    handleLoaderEvent.emit("loader", false);
    setMessages(chatConversation?.result?.transcripts)
    setConversationView(true);
  };
  const closeConversation = () => {
    setConversationView(false)
  }


  return (
    <div>
      <div className={`${styles.tableContainer} p-3 m-3`}>
        <div className={`${styles.clientList} mt-4`}>
          <table className={`${styles.table} w-100`}>
            <thead className={` {styles.tableHead}`}>
              <tr>
                <th className="ps-3 text-left">User Name</th>
                <th className="ps-3 text-left">Question</th>
                <th className="ps-2 text-left">Time Stamp</th>
                <th className="p-2 mx-2 text-left" >Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, index) => (
                <tr className={`${styles.tableRow} border-bottom`} key={index} >
                  <td className="ps-3 text-left">{item.username}</td>
                  <td className="ps-2 text-left">{item.question}</td>
                  <td className={"p-2 text-left"}>{moment(item.timeStamp).format("h:mma DD MMM, YYYY")}</td>
                  <td className={"p-2 text-left"}><button type='button' className={`${styles.viewTranscriptButton}`} onClick={()=>openConversation(item.conversationID)}>View Transcript</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="row p-0 m-0 mt-4">
          <div className="col-auto px-2 d-flex align-items-center">Rows Per Page</div>
          <div className="col-auto px-2 d-flex align-items-center">
            <button className={`btn ${styles.dropdownToggle}`} type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              {itemsPerPage}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <div className={styles.dropdownItem} onClick={() => setitemsPerPage(25)}>
                  25
                </div>
              </li>
              <li>
                <div className={styles.dropdownItem} onClick={() => setitemsPerPage(50)}>
                  50
                </div>
              </li>
            </ul>
          </div>
          <div className="col p-0 d-flex justify-content-end">
            <ReactPaginate
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={4}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
             {
              messages &&
              <Conversations messages={messages} close={closeConversation} show={conversationView}></Conversations>
             }
        </div>
      </div>
    </div>
  );
};

export default GaldermaChatScriptTable;
